import { render, staticRenderFns } from "./el-date-picker.vue?vue&type=template&id=196a7b4f&"
import script from "./el-date-picker.vue?vue&type=script&lang=js&"
export * from "./el-date-picker.vue?vue&type=script&lang=js&"
import style0 from "./el-date-picker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "el-date-picker.vue"
export default component.exports